import { FC } from 'react';
import { Dialog } from 'primereact/dialog';
import { ConnectPaymentAccount } from '../modules/events/components/connect-payment';
import { Button } from 'src/redesign/components/Button';
import styles from './payment-settings.module.scss';

export const PaymentSettingsModal: FC<any> = ({ setOpenPaymentConfig, openPaymentConfig }) => {
  const closeModal = () => setOpenPaymentConfig(false);

  const footer = (
    <div className="flex justify-content-end pt-3">
      <Button priority="primary" size="large" onClick={closeModal}>
        Close
      </Button>
    </div>
  );

  return (
    <Dialog
      visible={openPaymentConfig}
      onHide={closeModal}
      header="Payment Settings"
      draggable={false}
      footer={footer}
      style={{ width: '700px' }}
      modal
      dismissableMask
      className={styles.paymentDialog}
    >
      <div className={styles.dialogContent}>
        <ConnectPaymentAccount />
      </div>
    </Dialog>
  );
};
